'use client'

import { TooltipProvider } from '@canyon/ui/Tooltip'
import { ErrorBoundary, Provider } from '@rollbar/react'
import { Session } from 'next-auth'

import { rollbarConfig } from '@/lib/rollbar'
import { ApolloProvider } from '@/provider/Apollo'
import { AuthProvider } from '@/provider/Auth'
import { GlobalDialogsProvider } from '@/provider/GlobalDialogsProvider'
import { PostHogProvider } from '@/provider/Posthog'
import { ShepherdTourProvider } from '@/provider/ShepheredTourProvider'

interface IProviders {
  children: React.ReactNode
  token: Session['token']
}

export const Providers = ({ children, token }: IProviders) => {
  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <AuthProvider>
          <ShepherdTourProvider>
            <PostHogProvider>
              <TooltipProvider delayDuration={400}>
                <ApolloProvider token={token}>
                  <GlobalDialogsProvider>{children}</GlobalDialogsProvider>
                </ApolloProvider>
              </TooltipProvider>
            </PostHogProvider>
          </ShepherdTourProvider>
        </AuthProvider>
      </ErrorBoundary>
    </Provider>
  )
}
